import createHistory from 'history/createBrowserHistory';
import React from 'react';
import { Provider } from 'react-redux';
import { Switch, Route, Router } from 'react-router-dom';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxLogger from 'redux-logger';
import thunk from 'redux-thunk';

import LocalStorage from '../../components/LocalStorage/index';
import { url, routes } from '../../constants/routes';
import { reducers } from '../../reducers/index';
import System from '../System';
import '../../styles.css';

class App extends React.Component {
  render() {
    const history = createHistory();

    const store = createStore(
      combineReducers({
        ...reducers,
        router: routerReducer
      }),
      composeWithDevTools(
        applyMiddleware(thunk, routerMiddleware(history), reduxLogger)
      )
    );

    const routeList = routes.map((route, index) => (
      <Route
        key={`route_${index + 1}`}
        exact
        path={route.path}
        component={
          LocalStorage.getLogin() || route.path === url.WELCOME
            ? route.component
            : history.push(url.WELCOME)
        }
      />
    ));

    return (
      <Provider store={store}>
        <Router history={history}>
          <System>
            <Switch>{routeList}</Switch>
          </System>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.jsx